module.exports = __webpack_public_path__ + "img/boundingbox_jp.4bc6606.jpg";